// extracted by mini-css-extract-plugin
module.exports = {"title":"MenuTranscibedSection_title__deP6t","animate":"MenuTranscibedSection_animate__3KVm6","appear":"MenuTranscibedSection_appear__kEZGy"};